import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import * as React from 'react';
import OrderAttachments from '../CloudPlaner/OrderAttachments';
import Material from '../CloudPlaner/Material';
import WorkOrders from '../CloudPlaner/WorkOrders';
import Operations from '../CloudPlaner/Operations';
import ScheduledComponent from './CloudScheduler';
import OperationResourcesSchedulerList from './OperationResourcesSchedulerList';
interface IProps {}
interface IState {}
class SchedulerTabBar extends React.Component<IProps, IState> {
  private headerText: any;
  private tabObj: any;
  constructor(props: IProps) {
    super(props);
    this.headerText = [
      { text: 'Gantt' },
      { text: 'Work Orders' },
      { text: 'Operations' },
      { text: 'Assignments' },
    ];
  }
  componentDidMount() {
    // this.tabObj.element.classList.add('e-fill');
  }
  content0() {
    return <ScheduledComponent />;
  }
  content1() {
    return <WorkOrders />;
  }
  content2() {
    return <Operations needDidMount={false} />;
  }
  content3() {
    return <OperationResourcesSchedulerList />;
  }
  contentMaterial() {
    return <Material />;
  }
  contentAttachment() {
    return <OrderAttachments isSchedulerSide={true} />;
  }
  componentWillUnmount() {
    if (this.context?.setPlanId) {
      this.context.setPlanId(0);
    }
  }
  begin(args: any) {
    if (args.isSwiped) {
      args.cancel = true;
    }
  }
  render() {
    return (
      <div>
        <TabComponent
          ref={(tab) => (this.tabObj = tab)}
          selecting={this.begin.bind(this)}
          statelessTemplates={['directiveTemplates']}
        >
          <TabItemsDirective>
            <TabItemDirective
              header={this.headerText[0]}
              content={this.content0}
            />
            <TabItemDirective
              header={this.headerText[1]}
              content={this.content1}
            />
            <TabItemDirective
              header={this.headerText[2]}
              content={this.content2}
            />
            <TabItemDirective
              header={this.headerText[3]}
              content={this.content3}
            />
            <TabItemDirective
              header={{ text: 'Material' }}
              content={this.contentMaterial.bind(this)}
            />
            <TabItemDirective
              header={{ text: 'Attachments' }}
              content={this.contentAttachment.bind(this)}
            />
          </TabItemsDirective>
        </TabComponent>
      </div>
    );
  }
}
export default SchedulerTabBar;
